let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9W7iU")).then(() => parcelRequire('eLDKI'));